/**
 * Enum representing different view types for calendar heatmap charts
 */
export enum ViewType {
  /** Single month view showing one month at a time */
  MONTH = 'month',
  /** Quarter view showing 3 months at a time */
  QUARTER = 'quarter',
  /** Half-year view showing 6 months at a time */
  HALF_YEAR = 'half-year',
  /** Year view showing 12 months at a time */
  YEAR = 'year',
}
